// packages/ui/src/hooks/useLastDefined.ts
'use client';

import { useRef } from 'react';

/**
 * Keep the last non-null value a prop/state had.
 *
 * The `SmoothCollapse` rule in AGENTS.md § UI Animation: when the content inside
 * a closing collapse depends on a value that clears at the same instant as the
 * `in` condition, the content blanks out and the panel animates an empty box
 * shut. Rendering the retained value instead keeps the message visible for the
 * ~300 ms it takes to close.
 *
 * Written as a ref rather than state on purpose — retaining a value must never
 * schedule a render of its own.
 */
export function useLastDefined<T>(value: T | null): T | null {
  const retained = useRef<T | null>(value);
  if (value !== null) retained.current = value;
  return retained.current;
}
